/// <reference types="google.maps" />
type GeocodeResponseData = google.maps.GeocoderResult;

export function getGeocodeStreetText(data: GeocodeResponseData): string {
  const street_number = data.address_components.filter((component) =>
    component.types.includes('street_number')
  );

  const street = data.address_components.filter((component) =>
    component.types.includes('route')
  );

  return [...street_number, ...street].map((c) => c.short_name).join(' ');
}

export function getGeocodeCityText(
  data: GeocodeResponseData
): string | undefined {
  return data.address_components.find((c) =>
    c.types.includes('administrative_area_level_2')
  )?.long_name;
}

export function getGeocodeLocalityText(
  data: GeocodeResponseData
): string | undefined {
  return data.address_components.find((c) => c.types.includes('locality'))
    ?.long_name;
}

export function getGeocodeStateCode(
  data: GeocodeResponseData
): string | undefined {
  return data.address_components.find((c) =>
    c.types.includes('administrative_area_level_1')
  )?.short_name;
}

export function getGeocodeCountryText(
  data: GeocodeResponseData
): string | undefined {
  return data.address_components.find((c) => c.types.includes('country'))
    ?.long_name;
}

export function getGeocodePostcode(
  data: GeocodeResponseData
): string | undefined {
  return data.address_components.find((c) => c.types.includes('postal_code'))
    ?.long_name;
}
